(function () {
  const ROOT_SELECTOR = '.okeLoyalty, [data-oke-loyalty-embedded-widget]';
  const ID_PREFIX = 'clean-rewards-a11y';
  let scheduled = false;

  const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const ensureId = (element, fallback) => {
    if (!element) return '';
    if (!element.id) element.id = fallback;
    return element.id;
  };

  const setDecorativeIcons = (root) => {
    root.querySelectorAll('img.c-vipTierBadge-image').forEach((image) => {
      image.setAttribute('alt', '');
    });

    root.querySelectorAll('svg[role="img"], .c-icon svg, .c-customIcon svg').forEach((svg) => {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.removeAttribute('role');
    });
  };

  const describeHeroButton = (root) => {
    const hero = root.querySelector('#oke-loyalty-welcome-header');
    if (!hero) return;

    const heading = hero.querySelector('h1');
    const body = hero.querySelector('.c-textBlock-body');
    const button = hero.querySelector('button');
    if (!button) return;

    const describedBy = [heading, body]
      .map((element, index) => ensureId(element, `${ID_PREFIX}-hero-description-${index + 1}`))
      .filter(Boolean);

    if (describedBy.length) {
      button.setAttribute('aria-describedby', describedBy.join(' '));
    }
  };

  const labelGoButtons = (root) => {
    root.querySelectorAll('button').forEach((button) => {
      if (cleanText(button.textContent) !== 'Go') return;

      const card = button.closest('.c-customisableActionCard');
      const title = card && card.querySelector('.c-customisableActionCard-titleArea-title');
      const label = cleanText(title && title.textContent);

      if (label) {
        button.setAttribute('aria-label', `Go to ${label}`);
      }
    });
  };

  const describeActionCard = (card, index, prefix) => {
    if (!card) return;

    const title = card.querySelector('.c-customisableActionCard-titleArea-title');
    const subtitle = card.querySelector('.c-customisableActionCard-titleArea-subtitle');
    const titleText = cleanText(title && title.textContent);
    const subtitleText = cleanText(subtitle && subtitle.textContent);
    const ids = [];

    if (title) ids.push(ensureId(title, `${ID_PREFIX}-${prefix}-card-${index + 1}-title`));
    if (subtitle) ids.push(ensureId(subtitle, `${ID_PREFIX}-${prefix}-card-${index + 1}-description`));

    card.setAttribute('role', 'listitem');
    if (ids.length) {
      card.setAttribute('aria-labelledby', ids.join(' '));
    } else if (titleText || subtitleText) {
      card.setAttribute('aria-label', cleanText(`${titleText} ${subtitleText}`));
    }
  };

  const markActionCardLists = (root) => {
    const earnList = root.querySelector('#oke-loyalty-earn .c-customisableEarningRules-cardContainer');
    if (earnList) {
      earnList.setAttribute('role', 'list');
      earnList.setAttribute('aria-label', 'Ways to earn Wellness Points');
      earnList.querySelectorAll(':scope > .c-customisableActionCard').forEach((card, index) => {
        describeActionCard(card, index, 'earn');
      });
    }

    const redeemList = root.querySelector('#oke-loyalty-redeem .swiper-wrapper');
    if (redeemList) {
      redeemList.setAttribute('role', 'list');
      redeemList.setAttribute('aria-label', 'Rewards available to redeem');
      redeemList.querySelectorAll('.c-customisableActionCard').forEach((card, index) => {
        describeActionCard(card, index, 'redeem');
      });
    }
  };

  const markVipPerkLists = (root) => {
    root.querySelectorAll('#oke-loyalty-vip-tiers .c-customisableVipTiersCarousel-perks').forEach((list) => {
      list.setAttribute('role', 'list');
      list.setAttribute('aria-label', 'Tier benefits');
    });

    root.querySelectorAll('#oke-loyalty-vip-tiers .c-customisableVipTiersCarousel-perks-perk').forEach((perk) => {
      perk.setAttribute('role', 'listitem');
    });

    root.querySelectorAll('#oke-loyalty-vip-tiers .c-customisableVipTiersTabs-body-perks').forEach((panel) => {
      panel.setAttribute('aria-label', 'Tier benefits');
    });

    root.querySelectorAll('#oke-loyalty-vip-tiers .c-customisableVipTiersTabs-body-perks-perk').forEach((perk) => {
      const perkContent = perk.querySelector(
        '.c-customisableVipTiersTabs-body-perks-perk-content, .u-textStyleEmbedded--bodyBold'
      );
      const perkText = cleanText((perkContent || perk).textContent);

      perk.setAttribute('role', 'group');
      if (perkText) {
        perk.setAttribute('aria-label', perkText);
      }
    });
  };

  const labelVagueLinks = (root) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      const text = cleanText(link.textContent).toLowerCase();
      const href = link.getAttribute('href') || '';

      if (text === 'here' && href.includes('/pages/health-coach')) {
        link.setAttribute('aria-label', 'Schedule a call with a Wellness Coach');
      }
    });
  };

  const markSections = (root) => {
    [
      'oke-loyalty-earn',
      'oke-loyalty-redeem',
      'oke-loyalty-vip-tiers',
      'oke-loyalty-faq',
    ].forEach((sectionId) => {
      const section = document.getElementById(sectionId);
      if (!section) return;

      const heading = section.querySelector('h2, h3');
      if (!heading) return;

      const headingId = ensureId(heading, `${ID_PREFIX}-${sectionId}-heading`);
      section.setAttribute('role', 'region');
      section.setAttribute('aria-labelledby', headingId);
    });
  };

  const syncFaqState = (root) => {
    root.querySelectorAll('#oke-loyalty-faq .c-faqCustomisableItem').forEach((button, index) => {
      if (!(button instanceof HTMLButtonElement)) return;

      const question = button.querySelector('.c-faqCustomisableItem-question .u-textStyleEmbedded--bodyBold');
      const answer = button.querySelector('.c-faqCustomisableItem-answer');
      const questionText = cleanText(question && question.textContent);
      const isOpen = button.classList.contains('c-faqCustomisableItem--open');
      const buttonId = ensureId(button, `${ID_PREFIX}-faq-button-${index + 1}`);

      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (questionText) {
        button.setAttribute('aria-label', `${isOpen ? 'Collapse' : 'Expand'} ${questionText}`);
      }

      if (answer) {
        const answerId = ensureId(answer, `${ID_PREFIX}-faq-panel-${index + 1}`);
        button.setAttribute('aria-controls', answerId);
        answer.setAttribute('role', 'region');
        answer.setAttribute('aria-labelledby', buttonId);
        answer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        if (isOpen) {
          answer.removeAttribute('inert');
        } else {
          answer.setAttribute('inert', '');
        }
      }
    });
  };

  const syncVipTabs = (root) => {
    const tabs = root.querySelectorAll('#oke-loyalty-vip-tiers [role="tab"][id^="tier-tab-"]');
    const tablist = root.querySelector('#oke-loyalty-vip-tiers .c-customisableVipTiersTabs-header');
    const panel = root.querySelector('#oke-loyalty-vip-tiers .c-customisableVipTiersTabs-body-perks');
    const activeTab = root.querySelector(
      '#oke-loyalty-vip-tiers [role="tab"][aria-selected="true"], #oke-loyalty-vip-tiers [role="tab"].is-active'
    );
    const panelId = ensureId(panel, `${ID_PREFIX}-vip-tier-panel`);

    if (tablist) {
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-label', 'Clean Rewards tiers');
    }

    tabs.forEach((tab) => {
      if (panelId) {
        tab.setAttribute('aria-controls', panelId);
      }

      if (panel && activeTab) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', ensureId(activeTab, `${ID_PREFIX}-vip-tier-active-tab`));
      }
    });
  };

  const patchRewardsWidget = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      setDecorativeIcons(root);
      describeHeroButton(root);
      labelGoButtons(root);
      markActionCardLists(root);
      markVipPerkLists(root);
      labelVagueLinks(root);
      markSections(root);
      syncFaqState(root);
      syncVipTabs(root);
    });
  };

  const schedulePatch = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      patchRewardsWidget();
    });
  };

  document.addEventListener('DOMContentLoaded', schedulePatch);
  window.addEventListener('load', schedulePatch);
  document.addEventListener('click', (event) => {
    if (event.target && event.target.closest && event.target.closest('#oke-loyalty-faq')) {
      window.setTimeout(schedulePatch, 0);
      window.setTimeout(schedulePatch, 300);
    }
  });

  const observer = new MutationObserver(schedulePatch);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-label', 'aria-expanded'],
  });
})();
